import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CheckBox.html?raw';
import on from 'dojo/on';

import docu from './CheckBoxDocumentation.html?raw';
import { AccessibilityLabelsHelper, ColorHelpers, TranslationHelpers } from "../../../more/Helpers";
import Button from '../Button/Button';




interface customInputStyleConfig {
    borderColor?: string,
    color?: string,
    bgColor?: string
}

type CheckboxType = "checkbox" | "togglebutton" | "toggle" | "tristate" | "tristateQuestion" | "radio";

type alignment = "iconleft" | "iconright";
class CheckBox extends compose(_LabelInputBase) {
    templateString: any = template;

    // _StatefulBase overloads----------properties------------------------start
    validationMsgNodeContainer = "errorMsgNode";
    // _StatefulBase overloads-------------properties---------------------end

    private inputNode: HTMLInputElement;
    private inputContainer: HTMLDivElement;
    private labelNodeLeft: HTMLLabelElement;
    private labelNodeRight: HTMLLabelElement;
    private errorMsgNode: HTMLSpanElement;
    private checkBoxContainer: HTMLElement;
    private mainContainer: HTMLElement;

    private toggleStyle: boolean = false; // ein-ausgeschaltet icons: fa-toggle-off || fa-toggle-on

    checked: boolean = false;
    isReadonly: boolean = false;

    private defaultValue: boolean = false; 

    private isTristate: boolean = false;

    private isCustomStyleEnabled: boolean = true;

    private checkedIconContent: string = '\f00c'; // checked icon
    private tristateIconContent: string = '\f0c8'; // asterisk - default - subject to changes

    private displayStyle: CheckboxType = "checkbox";
    private labelAlignment: "left" | "right" = "right";

    private checkedClassName: string = "checked";
    private uncheckedClassName: string = "unchecked";
    private tristateClassName: string = "tristate";

    private checkedLabel: string = null;
    private uncheckedLabel: string = null;
    private tristateLabel: string = null;
    private useConditionalLabels: boolean = false;

    private toggleBtn: MdsLax<InstanceType<typeof Button>> = null;

    //activeLabelNodeName: "labelNodeRight" | "labelNodeLeft" = "labelNodeRight"; // default visible label node 
    name: string;

    _value: boolean = false;


    focus() {
        this.inputNode.focus();
    }

    private _setTypeAttr(style) {
        this._setStyleAttr(style);
    }
    private _setStyleAttr(style: CheckboxType) {
        if (style) {
            switch (style.toUpperCase()) {
                case "TOGGLE":
                    style = "toggle";
                    break;
                case "TRISTATE":
                    style = "tristate";
                    break;

                case "TOGGLEBUTTON":
                    style = "togglebutton";
                    break;

            }
            
        } 

        this.setType(style);
    }
    setType(style: CheckboxType) {
        this.UiModder.domClass.toggle(this.inputContainer, "radio", style == "radio");
        this.UiModder.domClass.toggle(this.inputContainer, "tristate", style == "tristate");
        this.UiModder.domClass.toggle(this.inputContainer, "tristate tristateQuestion", style == "tristateQuestion");
        this.UiModder.domClass.toggle(this.inputContainer, "toggle", style == "toggle");
        this.UiModder.domClass.toggle(this.inputContainer, "toggleButton", style == "togglebutton");

        if (style == "togglebutton") {
            this.toggleBtn = new Button();
            this.toggleBtn.setup({
                callback: lang.hitch(this, this.setNextInputValue)
            });
            this.toggleBtn.placeAt(this.domNode);
            this.hideNode(this.mainContainer);
            if (this.useConditionalLabels) this._handleConditionalLabels();
            else this.setLabelValue();
            this.setLabelAlignment(this.labelAlignment);
            this._setReadonlyStyle();
        } else if (this.displayStyle == "togglebutton") {
            this.hideNode(this.mainContainer, false);
        }

        this.displayStyle = style;

        this.isTristate = style == "tristate" || style == "tristateQuestion";

        if (this._value == null && !this.isTristate) this.setValue(false);
    }

    private paddings: "default" | "bigger";

    setPaddings(style: "default" | "bigger") {
        this.UiModder.domClass.remove(this.domNode, this.paddings + "Paddings");

        switch (style) {

            default:
                this.paddings = "default";
                break;

            case "bigger":
            case "default":
                this.paddings = style;
        }

        this.UiModder.domClass.add(this.domNode, this.paddings + "Paddings");
    }
    private _setPaddingsAttr(style: string): void {
        this.setPaddings(style as any);
    }
    /// events ------------------------------start

    private _onClick_LabelNode(evt: Event): void {
        evt.stopPropagation(); // oder nur wenn nicht disabled und nicht readonly? hmm...

    }

    private _onClick_mainContainer(evt: MouseEvent) {
        this.emit("click", evt);

        if (!this.isReadonly) {
            this.isFocused = true;
            this.setNextInputValue();
        } else {
            evt.preventDefault();
            //console.log("Checkbox is readonly");
        }
    }

    private _onClickToggleButton(evt: MouseEvent) {
        this.isFocused = true;

        this.setNextInputValue();
    }

    private _onClick_inputNode(evt): void {
        evt.stopPropagation();
        if (!this.isReadonly) {
            this.isFocused = true;
            this.setNextInputValue();

        } else {
            evt.preventDefault();
            //console.log("Checkbox is readonly");
        }
    }

    private _onClickLabel(evt: Event): void {
        this._onClick_inputNode(evt);
    }

    /// events ------------------------------end
    //---------------------------- Styling -----------------------------------------------START
    //icons---------------------
    //setCustomInputStyle(customInputStyle: customInputStyleConfig, sType: 'checked' | 'unchecked' | 'tristate'): void {
    //    // sets the style values of the css pseudoelement (custom input displayed) by setting the value of the corresponding css variables
    //    // !! values of customInputStyle must be valid css values !!

    //    if (customInputStyle.bgColor) this.domNode.style.setProperty("--moreCoreCheckBox_customBgColor" + "_" + sType, customInputStyle.bgColor);
    //    if (customInputStyle.color) this.domNode.style.setProperty("--moreCoreCheckBox_customColor" + "_" + sType, customInputStyle.color);
    //    if (customInputStyle.borderColor) this.domNode.style.setProperty("--moreCoreCheckBox_customBorderColor" + "_" + sType, customInputStyle.borderColor);
    //}

    //---------------------------- Styling -----------------------------------------------END
    setNextInputValue(): void {
        // set value depending on tristate. values order: | true - tristate - false | if default is false or undefined

        if (typeof this._value == "undefined" || this._value === false) {
            this.setValue(true);
        } else if (this._value == true && this.isTristate === true) {
            this.setValue(null);
        } else if (this.isTristate === false || (this._value === null && this.isTristate === true)) {
            this.setValue(false);
        } else {
            console.error("Error: unexpected _value/tristate type ");
        }

    }

    getChecked(): boolean {
        return this.checked;
    }

    getName(): string {
        return this.name;
    }

    setName(name: string) {
        this.name = name;
        this.UiModder.domAttr.set(this.inputNode, name, name);
    }

    setAlignment(alignment: alignment) {
        this.UiModder.domClass.toggle(this.domNode, "iconRight", alignment == "iconright");
        this.setLabelAlignment(alignment == "iconleft" ? "right" : "left");
    }

    /**
     * Setzt die Checkbox in einen Modus, bei dem das Label sich mit dem Wert ändert (zB. angehakt 'Ja', abgewählt 'Nein')
     * Labels auf null setzen, um den Modus zu beenden.
     * @param checkedLabel
     * @param uncheckedLabel
     * @param tristateLabel Tristate-Beschriftung (null-Wert bzw. "nicht ja und nicht nein")
     */
    setConditionalLabels(checkedLabel: string, uncheckedLabel: string, tristateLabel?: string) {
        if (checkedLabel && uncheckedLabel) {
            this.useConditionalLabels = true;

            this.checkedLabel = TranslationHelpers.tryTranslate(checkedLabel);
            this.uncheckedLabel = TranslationHelpers.tryTranslate(uncheckedLabel);
            this.tristateLabel = TranslationHelpers.tryTranslate(tristateLabel);
        } else {
            this.useConditionalLabels = false;
        }

        this._handleConditionalLabels();
    }


    private _handleConditionalLabels() {
        let lbl = this._label;
        if (this.useConditionalLabels) {
            
            switch (this._value) {
                case true:
                    lbl = this.checkedLabel;
                    break;

                case false:
                    lbl = this.uncheckedLabel;
                    break;

                default:
                    if (this.isTristate && (this.tristateLabel || this.tristateLabel == "") /* "" zulassen! */) {
                        lbl = this.tristateLabel;
                    }
                    break;
            }
        }

        this.setLabelValue(lbl);
    }


    protected _setReadonlyStyle(): void {
        if (this.getReadonly() === true) {
            this.UiModder.domAttr.set(this.inputNode, "disabled", true);
            this.UiModder.domClass.add(this.inputContainer, "disabled");

        } else {
            this.UiModder.domAttr.remove(this.inputNode, "disabled");
            this.UiModder.domClass.remove(this.inputContainer, "disabled");
        }

        if( this.toggleBtn && this.displayStyle == "togglebutton") this.toggleBtn.setReadonly(this.isReadonly);

        if (this.labelNodeLeft) {
            this.UiModder.domClass.toggle(this.labelNodeLeft, "w3-disabled", this.isReadonly);
        } if (this.labelNodeRight) {
            this.UiModder.domClass.toggle(this.labelNodeRight, "w3-disabled", this.isReadonly);
        }
    }

    /**
     * Färbt die Checkbox, indem es eine übergebene EntityAPI-Color ausliest.
     */
    setColorationFromProperty(color: more.EntityAPIColor) {
        let hexColorBG = ColorHelpers.getHexColorFromProperty(color, "BG");
        let hexColorTXT = ColorHelpers.getHexColorFromProperty(color, "TXT");

        this.setColor(hexColorBG, hexColorTXT);
    }

    setColor(colorBG: string, colorTXT: string) {
        let hexColorBG = ColorHelpers.getHexColorFromString(colorBG);
        let hexColorTXT = ColorHelpers.getHexColorFromString(colorTXT);

        this.domNode.style.removeProperty("--bgColor");
        this.domNode.style.removeProperty("--txtColor");

        this.UiModder.domClass.remove(this.domNode, "customColor darkBG");

        if (hexColorBG) {
            this.domNode.style.setProperty("--bgColor", hexColorBG);

            this.UiModder.domClass.add(this.domNode, "customColor");
           
        }

        if (!hexColorTXT) {
            if (hexColorBG && ColorHelpers.isDarkColor(hexColorBG)) {
                this.UiModder.domClass.add(this.domNode, "darkBG");
            }
        }
        else {
            this.domNode.style.setProperty("--txtColor", hexColorTXT);

            this.UiModder.domClass.add(this.domNode, "customColor");
        }
    }

    setIsTristate(bool: boolean): void {
        this.isTristate = bool;
    }

    setLabelAlignment(nodeName: "right" | "left"): void {
        //soll das richtige label zeigen und das falsche (nicht aktive) verstecken.
        //this.activeLabelNodeName = nodeName;
        this.UiModder.domClass.remove(this.inputContainer, "left right");

        if (nodeName == "left") {
            this.UiModder.domClass.add(this.inputContainer, "left");

            this.labelAlignment = nodeName;
            
        } else if (nodeName == "right") {
            this.UiModder.domClass.add(this.inputContainer, "right");

            this.labelAlignment = nodeName;
        }

        
        this.setLabelValue();
    }
    protected setInputValueStyle(): void {

        // die Input.checked kann nur true oder false sein, aber die Pseudoelemente können verschiedene states darstellen
        // daher müssen wir die Klassen manuell auf das labelNode setzen

        if (this.isTristate && !this.isCustomStyleEnabled) console.warn("morecore Checkbox: Enable custom styles for proper tristate usage");

        this.inputNode.checked = this.checked;
        let currentActiveClass = "";

        if (this.isCustomStyleEnabled == true) {
            if (this.toggleStyle === true) {

                this.UiModder.domClass.remove(this.inputContainer, "toggleStyle_on");
                this.UiModder.domClass.remove(this.inputContainer, "toggleStyle_off");

                if (this._value === false || typeof this._value == "undefined") { // undefined sollte nicht passieren
                    this.UiModder.domClass.add(this.inputContainer, "toggleStyle_off");
                } else if (this._value === true) {
                    this.UiModder.domClass.add(this.inputContainer, "toggleStyle_on");
                } else if (this._value === null) {
                    console.warn("morecore checkbox: tristate should be disabled for toggle mode")
                }

            } else {
                this.UiModder.domClass.remove(this.domNode, this.tristateClassName);
                this.UiModder.domClass.remove(this.domNode, this.checkedClassName);
                this.UiModder.domClass.remove(this.domNode, this.uncheckedClassName);

                if (this._value === false) { 
                    this.UiModder.domClass.add(this.domNode, this.uncheckedClassName);
                    currentActiveClass = this.uncheckedClassName;
                } else if (this._value === true) {
                    this.UiModder.domClass.add(this.domNode, this.checkedClassName);
                    currentActiveClass = this.checkedClassName;
                } else if (this._value === null && this.isTristate === true) {
                    this.UiModder.domClass.add(this.domNode, this.tristateClassName);
                    currentActiveClass = this.tristateClassName;
                } else if (this._value === null && this.isTristate != true) {
                    this.UiModder.domClass.add(this.domNode, this.uncheckedClassName);
                    currentActiveClass = this.uncheckedClassName;
                } else {
                    console.error(this.id + ": invalid value?", this._value)
                }
            }
        }



        if (this.displayStyle == "togglebutton" && this.toggleBtn) {
            if (this.labelAlignment == "right") {
                this.toggleBtn.setIconLeft(this._value == true ? "fas fa-check-circle" : this._value === false ? "far fa-circle" : "far fa-question-circle");
                this.toggleBtn.setIconRight(null);
            } else {
                this.toggleBtn.setIconRight(this._value == true ? "fas fa-check-circle" : this._value === false ? "far fa-circle" : "far fa-question-circle")
                this.toggleBtn.setIconLeft(null);
            }
        }

        if (this.useConditionalLabels) this._handleConditionalLabels();
        
    }
    // _Stateful- und LabelInput-Base overloads----------------methods------------------start

    getValue(): boolean {
        return this._value;
    }

    setValue(newValue: boolean, suppressChangeEvent: boolean = false): void {

        if (newValue !== true && newValue !== false) {
            if (this.isTristate) {
                newValue = null;
            } else if (newValue == null) newValue = false;
            else if (newValue == "") newValue = false;
            else if (typeof newValue == "undefined") newValue = false;
            else if (newValue) newValue = true;
        }
        this._value = newValue;

        // checked is true if this._value is true or tristate
        this.checked = this._value === false? false : true;

        this.setInputValueStyle();

        this.validateInput();

        let delay = 5;
        if (this.isFocused) {
            // bei Clickevent wurde das Focused gesetzt, d.h. es ist eine Benutzerinteraktion
            // etwas mehr Verzögerung zulassen:
            delay = 100;
            this.isFocused = false
        }

        if (suppressChangeEvent === true) { }
        else {
            
            this.__delayValueChangeEmit(delay);
        }
    }

    protected customValidation(): boolean {
        // hier die individuelle Validierungsoperation
        // in der KindKlasse ausprogrammieren

        // Beispiel (default):
        let result: boolean = true;

        if (this.isMandatory == true) {
            if (this.checked === false) {
                result = false;
            }
        }

        return result;
    }

    setLabelValue(newVal?: string): void {
        let lbl = this._label;
        
        if (newVal || newVal == "") {
            lbl = newVal;
        }
        if (lbl || lbl == "") {
            this.labelNodeLeft.innerHTML = lbl;
            this.labelNodeRight.innerHTML = lbl;

            if (this.toggleBtn && this.displayStyle == "togglebutton") {
                this.toggleBtn.setLabel(lbl);
            }
        }
    }
    setDefaultValue(value: boolean): void {
        // value, which is set at the beginning
        this.defaultValue = value;
    }

    setIsReadOnly(bool: boolean, bUpdateCurrentStyle?: boolean): void {
        this.isReadonly = bool;
        if (bUpdateCurrentStyle) {
            this._setReadonlyStyle();
        }
    }

    setChecked(bool: boolean, bSuppressChangeEvent?: boolean): void {
        // wrapper for setValue()
        this.setValue(bool, bSuppressChangeEvent)
    }

    //_Stateful- und LabelInput-Base overloads----------------methods------------------end

    // -----------------------------------------Doku
    getDocumentationContent(): string {
        return docu;
    }


    private _getNameAttr(): string {
        return this.getName();
    }

    private _setNameAttr(name: string): void {
        this.setName(name);
    }

    private _getCheckedAttr(): boolean {
        return this.getChecked();
    }
    private _setCheckedAttr(bool : boolean): void {
        this.setChecked(bool);
    } 
    private _setIsTristateAttr(bool: boolean): void {
        this.setIsTristate(bool);
    }
    private _setDefaultValueAttr(value: boolean): void {
        this.setDefaultValue(value);
    }

    _setIsReadOnlyAttr(bool: boolean): void {
        this.setIsReadOnly(bool);
    }

    _setLabelNodeAlignmentAttr(align: "right" | "left"): void {
        this.setLabelAlignment(align);
    }

    private _onKeyDown(evt: KeyboardEvent) {
        if (this.isReadonly) return;
        
        if (evt.key == "space" || evt.key == " ") {
            this.setNextInputValue();
            evt.stopPropagation();
                evt.preventDefault();
        }
    }

    // LC ------------------------------------------------

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setLabelValue();

        if (this.getValue() === null || typeof this.getValue() == "undefined") {

            if (typeof this.defaultValue != "undefined") this.setValue(this.defaultValue, true);
        }

        on(this.domNode, "keydown", lang.hitch(this, this._onKeyDown));

        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.labelNodeLeft, labelIdValue: "labelLeft"
            }, {
                labelElement: this.labelNodeRight, labelIdValue: "labelRight"
            }],
            this.inputNode,
            this.id);
    }
}

export default mdsWidget(CheckBox);